import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './SpotlightHero.css';

const SpotlightHero = ({ image, title, description, tagline }) => {
    return (
        <section className="spotlight-hero-section">
            <Container fluid className="py-5">
                <Row className="justify-content-center">
                    <Col xs={11} md={11} lg={11} xl={11} xxl={9}>
                        <div className="text-center mb-4">
                            <img
                                src={image}
                                alt={title}
                                className="spotlight-detail-hero-image img-fluid"
                                draggable="false"
                            />
                        </div>

                        <div className="spotlight-hero-content">
                            <h1 className="spotlight-detail-title fw-semibold text-start mb-4">
                                {title}
                            </h1>
                            <p className="spotlight-detail-description text-start fs-5 mb-3">
                                {description}
                            </p>
                            {tagline && (
                                <p className="spotlight-detail-tagline text-start fs-5 fw-semibold">
                                    {tagline}
                                </p>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

SpotlightHero.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    tagline: PropTypes.string,
};

export default SpotlightHero;
